import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
  { // 登录
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  { // 忘记密码
    path: '/forget',
    component: () => import('@/views/forget/index'),
    hidden: true
  },
  { // 注册（保留原注册页面作为备份）
    path: '/register',
    component: () => import('@/views/register/index'),
    hidden: true
  },
  { // 用户注册
    path: '/register/user',
    component: () => import('@/views/register/userRegister'),
    hidden: true
  },
  { // 造价师注册
    path: '/register/engineer',
    component: () => import('@/views/register/engineerRegister'),
    hidden: true
  },
  { // 供应商注册
    path: '/register/supplier',
    component: () => import('@/views/register/supplierRegister'),
    hidden: true
  },
  { // 选择账号类型
    path: '/type',
    component: () => import('@/views/type/index'),
    hidden: true
  },
  { // 造价师注册
    path: '/engineer',
    component: () => import('@/views/engineer/index'),
    hidden: true
  },
  { // 供应商注册
    path: '/supplier',
    component: () => import('@/views/supplier/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  { // 首页
    path: '/',
    component: Layout,
    redirect: '/news_home',
    children: [
      {
        path: 'news_home',
        name: 'news_home',
        component: () => import('@/views/news_home/index'),
        meta: { title: 'News Home', icon: 'dashboard' },
        hidden: true
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'Dashboard', icon: 'dashboard' },
        hidden: true
      }
    ]
  },
  { // 材价信息
    path: '/material',
    component: Layout,
    children: [{
      path: '',
      name: 'Material',
      component: () => import('@/views/material/index'),
      meta: { title: 'Material', icon: 'material' }
    }, { // 供应商列表
      path: 'supplierList',
      name: 'SupplierList',
      component: () => import('@/views/material/supplierList'),
      meta: { title: 'SupplierList', icon: 'supplierList' }
    }, { // 名片展示
      path: 'cardList',
      name: 'CardList',
      component: () => import('@/views/material/cardList'),
      meta: { title: 'CardList', icon: 'cardList' }
    }]
  },
  { // 造价案例
    path: '/costcases',
    component: Layout,
    redirect: '/costcases/index',
    children: [{
      path: 'index',
      name: 'Costcases',
      component: () => import('@/views/costcases/index'),
      meta: { title: 'Costcases', icon: 'costcases' }
    }, { // 案例筛选
      path: 'caseList',
      name: 'CaseList',
      component: () => import('@/views/costcases/caseList'),
      meta: { title: 'CaseList', icon: 'caseList' }
    }, { // 案例详情
      path: 'caseDetail',
      name: 'CaseDetail',
      component: () => import('@/views/costcases/caseDetail'),
      meta: { title: 'CaseDetail', icon: 'caseDetail' }
    }, { // 个人简介
      path: 'caseNews',
      name: 'CaseNews',
      component: () => import('@/views/costcases/caseNews'),
      meta: { title: 'CaseNews', icon: 'caseNews' }
    }]
  },
  { // 造价师服务
    path: '/service',
    component: Layout,
    redirect: '/service/index',
    children: [{
      path: 'index',
      name: 'Service',
      component: () => import('@/views/service/index'),
      meta: { title: 'Service', icon: 'service' }
    }, {
      path: 'detail',
      name: 'ServiceDetail',
      component: () => import('@/views/service/detail'),
      meta: { title: 'ServiceDetail', icon: 'serviceDetail' }
    }]
  },
  { // 咨询详情
    path: '/consulting',
    component: Layout,
    children: [{
      path: 'index',
      name: 'Consulting',
      component: () => import('@/views/consulting/index'),
      meta: { title: 'Consulting', icon: 'consulting' }
    }]
  },
  { // 造价问答
    path: '/costqa',
    component: Layout,
    redirect: '/costqa/index',
    children: [{
      path: 'index',
      name: 'CostQA',
      component: () => import('@/views/costqa/index'),
      meta: { title: 'CostQA', icon: 'form' }
    }]
  },
  { // 个人中心
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    children: [{
      path: 'index',
      name: 'Profile',
      component: () => import('@/views/profile/index'),
      meta: { title: 'Profile', icon: 'user' }
    }, {
      path: 'shiming',
      name: 'Shiming',
      component: () => import('@/views/profile/shiming'),
      meta: { title: 'Shiming', icon: 'user' }
    }, {
      path: 'bill',
      name: 'Bill',
      component: () => import('@/views/profile/bill'),
      meta: { title: 'Bill', icon: 'user' }
    }, {
      path: 'invoice',
      name: 'Invoice',
      component: () => import('@/views/profile/invoice'),
      meta: { title: 'Invoice', icon: 'user' }
    }, {
      path: 'tixian',
      name: 'Tixian',
      component: () => import('@/views/profile/tixian'),
      meta: { title: 'Tixian', icon: 'user' }
    }, {
      path: 'uploadCase',
      name: 'UploadCase',
      component: () => import('@/views/profile/uploadCase'),
      meta: { title: 'UploadCase', icon: 'user' }
    }, {
      path: 'caseDetail',
      name: 'ProfileCaseDetail',
      component: () => import('@/views/profile/caseDetail'),
      meta: { title: 'ProfileCaseDetail', icon: 'user' }
    }, {
      path: 'consulting',
      name: 'Consulting',
      component: () => import('@/views/profile/consulting'),
      meta: { title: 'Consulting', icon: 'user' }
    }, {
      path: 'costEngineerCertification',
      name: 'CostEngineerCertification',
      component: () => import('@/views/profile/costEngineerCertification'),
      meta: { title: '造价师认证', icon: 'user' }
    }, {
      path: 'supplierCertification',
      name: 'SupplierCertification',
      component: () => import('@/views/profile/supplierCertification'),
      meta: { title: '供应商认证', icon: 'user' }
    }, {
      path: 'rechargePolicy',
      name: 'RechargePolicy',
      component: () => import('@/views/profile/rechargePolicy'),
      meta: { title: '政策说明', icon: 'user', public: true }
    }]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
